// extracted by mini-css-extract-plugin
export var progressBar = "_kt-0";
export var progressBarInner = "_kt-1";